import { getCookie, setCookie } from '../../util/cookie';

// Most functions in this file are based on
// https://github.com/mixpanel/mixpanel-js/blob/master/src/utils.js
/* istanbul ignore next */
const getDevice = () => {
  const ua = navigator.userAgent;

  if (ua.includes('Windows Phone') || ua.includes('WPDesktop')) {
    return 'Windows Phone';
  } else if (ua.includes('iPad')) {
    return 'iPad';
  } else if (ua.includes('iPod')) {
    return 'iPod Touch';
  } else if (ua.includes('iPhone')) {
    return 'iPhone';
  } else if (/(BlackBerry|PlayBook|BB10)/i.test(ua)) {
    return 'BlackBerry';
  } else if (ua.includes('Android')) {
    return 'Android';
  }
  return '';
};

let cookieAppName = 'map';

const cookieKey = (token: string) => `mp_${token}_${cookieAppName}`;

type Cookie = {
  distinct_id: string;
  $device_id: string;
  $initial_referrer: string;
  $initial_referring_domain: string;
  $user_id: number;
};

/* istanbul ignore next */
const getCookieData = (token: string): Cookie | null => getCookie(cookieKey(token));

/* istanbul ignore next */
const setCookieData = (token: string, data: Record<string, any>) =>
  setCookie(cookieKey(token), data, 60 * 60 * 24 * 365);

type Set = {
  token: string;
  id: string;
  deviceId?: string;
  userId?: number;
};

const baseData = {
  distinct_id: '',
  $user_id: 0,
  $device_id: '',
  $device: getDevice(),
  $initial_referrer: '$direct',
  $initial_referring_domain: '$direct',
};

/* istanbul ignore next */
const cookie = {
  get: (token: string) => getCookieData(token),
  set: ({ token, id, deviceId, userId }: Set) => {
    const data = { ...baseData, distinct_id: id, $user_id: userId };
    if (deviceId) {
      data.$device_id = deviceId;
    }
    setCookieData(token, data);
    return data;
  },
  setCookieAppName: (name: string) => {
    cookieAppName = name;
  },
};

export default cookie;
